import { render, staticRenderFns } from "./ProductStatusCard.vue?vue&type=template&id=4959f8be&scoped=true&"
import script from "./ProductStatusCard.vue?vue&type=script&lang=js&"
export * from "./ProductStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductStatusCard.vue?vue&type=style&index=0&id=4959f8be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959f8be",
  null
  
)

component.options.__file = "ProductStatusCard.vue"
export default component.exports